import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { BBCommonProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';
import css from './Box.scss';

type Props = BBCommonProps;

class Box extends React.Component<Props> {
	renderEditable() {
		const props = { ...this.props.editableModeProps?.nodeProps };
		return this.renderDefault(props);
	}

	renderDefault(props = {}) {
		const { nodeProps } = this.props.uiConfig;
		// @ts-expect-error ts-migrate FIXME
		const className = classnames(css.box, nodeProps.className, props.className);

		return (
			<div
				{...nodeProps}
				{...this.props.stateAttrs}
				{...this.props.eventListeners}
				{...props}
				data-box-type={_.get(this.props, ['uiConfig', 'componentProps', 'other', 'boxType'])}
				className={className}
				ref={this.props.containerRef}
			>
				{this.props.children}
			</div>
		);
	}

	render() {
		return this.props.isEditableMode ? this.renderEditable() : this.renderDefault();
	}
}

export default withCardTransitionContext(Box);
